<template>
  <div>
    <h2>IP Voice</h2>
    <ag-grid-vue
      domLayout="autoHeight"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "ip-voice",
  props: {
    rowData: {
      type: Array,
      default: () => [],
    },
    ratePlans: {
      type: Array,
      default: () => [],
    },
    handsets: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AgGridVue,
  },
  data: () => ({
    columnDefs: [],
  }),
  beforeMount() {
    this.setColumnDefs();
  },
  methods: {
    setColumnDefs() {
      let vm = this;
      vm.columnDefs = [
        { headerName: "Extension", field: "extensionNo", maxWidth: 100 },
        { headerName: "Name", field: "extensionName" },
        { headerName: "Contract Length", field: "contractLengthMonths" },
        {
          headerName: "Plan",
          field: "ratePlanID",
          cellRenderer: function(params) {
            const plan = vm.ratePlans.filter(
              (x) => x.ratePlanID === parseInt(params.value)
            );

            return plan.length > 0 ? plan[0].ratePlanDescription : "";
          },
        },
        {
          headerName: "Handset",
          field: "handsetID",
          cellRenderer: function(params) {
            const handset = vm.handsets.filter(
              (x) => x.handsetID === parseInt(params.value)
            );

            return handset.length > 0 ? handset[0].model : "";
          },
        },
        { headerName: "ANI", field: "outboundANI" },
        { headerName: "Email", field: "voicemailEmail" },
        { headerName: "Mobile", field: "mobileTwinning", maxWidth: 168 },
      ];
    },
  },
};
</script>
